import React, { FC } from 'react';
import { CommodityType } from '@bechtel/types';
import { Tabs, TabProps, TabPanels } from '@bechtel/gds';
import { CommodityButton, CommodityTab, CommodityTabList } from './styled';
import { CommodityTypesTabsProps } from './types';

export const CommodityTypesTabs: FC<CommodityTypesTabsProps> = ({ commodityTypes, children }) => {
  return (
    <Tabs>
      <CommodityTabList>
        {commodityTypes.map((commodityType: CommodityType) => {
          return (
            <CommodityTab key={commodityType.id}>
              {({ selected }: TabProps) => {
                return <CommodityButton selected={selected}>{commodityType.name}</CommodityButton>;
              }}
            </CommodityTab>
          );
        })}
      </CommodityTabList>
      <TabPanels>{children}</TabPanels>
    </Tabs>
  );
};
